<template>
  <div class="app-container">
    <div>
    <el-button
      size="small"
      type="primary"
      class="go-back"
      @click.stop="goBack()"
    >
      返回
    </el-button><span style="font-size: 18px;margin-left: 10px;margin-top: 8px"  >当前圈子：{{this.forumGroupName}}</span></div>

    <el-card class="box-card">
      <!-- 顶部栏 -->
      <div class="topbar">
        <div>
          <el-input
            v-model="searchValue"
            size="small"
            placeholder="关键字支持： 标题 / 描述 / 姓名 / 昵称 / 帖子类型"
            prefix-icon="el-icon-search"
            class="search-input"
            clearable
          />
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            :disabled="!searchValue"
            @click.stop="search()"
          >
            搜索
          </el-button>
          <el-button
            type="info"
            icon="el-icon-refresh"
            size="small"
            @click.stop="reset()"
          >
            重置
          </el-button>
        </div>
      </div>
      <!-- 内容 -->
      <el-table
        v-loading="loading"
        :data="allForumsList"
        :header-cell-style="{ background: '#F5F7FA' }"
        style="width: 100%; margin-bottom: 20px"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form
                    label-position="left"
                    inline
                    class="demo-table-expand"
            >
              <el-col :span="24">
                <el-form-item label="内容">
                  <span>{{scope.row.customDescription===""?"无":scope.row.customDescription}}</span>
                </el-form-item>
              </el-col>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="forumId" label="#" align="center" width="60"/>
        <el-table-column prop="forumType" label="文本形式" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.forumType | forumTypeTransform }}
          </template>
        </el-table-column>
        <el-table-column
                prop="customTitle"
                label="标题"
                align="center"
                show-overflow-tooltip
                width="160"
        >
          <template slot-scope="scope">
            <span style="color: darkgreen">{{ scope.row.customTitle}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="forumCategory" label="话题类型" align="center" />
        <el-table-column label="发布时间" align="center" width="100">
          <template slot-scope="scope">
              <span style="color: forestgreen">
              {{ scope.row.createTime | ellipsis }}
              </span>
          </template>
        </el-table-column>
        <el-table-column
                prop="nickname"
                label="发布人"
                align="center"
                show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.nickname }}<span v-if="scope.row.isUltraExpert">(专家)</span> </template>
        </el-table-column>
        <el-table-column v-if="userDataTypeOptions.length > 0" prop="userDataType" label="所属领域" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.userDataType | userDataTypeTransform }}
          </template>
        </el-table-column>
        <el-table-column prop="pageViews" label="浏览" sortable align="center" width="50">
          <template slot-scope="scope">
            {{ scope.row.pageViews }}
          </template>
        </el-table-column>
        <el-table-column prop="commentCount" label="评论" sortable align="center" width="50">
          <template slot-scope="scope">
            {{ scope.row.commentCount }}
          </template>
        </el-table-column>
        <el-table-column label="圈内置顶"  align="center" width="60">
          <template slot-scope="scope"><el-switch v-model="scope.row.isGroupTop" active-color="#03be56" :active-value=true :inactive-value=false  @change="setForums(scope.row, 1)"></el-switch></template>
        </el-table-column>
        <el-table-column label="广场显示"  align="center" width="60">
          <template slot-scope="scope"><el-switch v-model="scope.row.isHideOnSquare" active-color="#03be56" :active-value=false :inactive-value=true  @change="setForums(scope.row, 3)"></el-switch></template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              @click.stop="goToUltrasonicDetail(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              size="small"
              :type="scope.row.isDeleted ? 'warning' : 'danger'"
              @click.stop="deleteOrBackForums(scope.row)"
            >
              {{ scope.row.isDeleted ? '恢复' : '删除' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        v-show="totalCount > pageSize"
        background
        layout="prev, pager, next"
        :total="totalCount"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="currentChange"
      />
      <p style="color: dimgrey;margin-left: 10px">共{{totalCount}}条</p>
    </el-card>
  </div>
</template>

<script>
import { setPostTop } from '@/api/ultrasonicGroupsPost'
import { deleteOrBackForums,getAllForumsList ,  setForums} from '@/api/ultrasonic'
import {getUserType} from "@/utils/userutil";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";
import {go2UltrasonicDetail} from "@/utils/UIHelper";

export default {
  data() {
    return {
      navigationKey:"ultrasonicGroupPost",

      ForumGroupID: '', // 超人圈群组ID
      forumGroupName:'',
      loading: false, // 加载开关
      searchValue: '', // 搜索内容
      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
      allForumsList: [], // 超人圈群组帖子列表
      part:null,
      userDataTypeOptions:[]
    }
  },
  created() {
    let navigationObj = getNavigationItemObj(this.navigationKey)
    this.currentPage = navigationObj.currentPage
    this.ForumGroupID = navigationObj.ForumGroupID
    this.searchValue = navigationObj.searchValue

    this.userDataTypeOptions = getUserType()
    this.ForumGroupID = this.$route.query.ForumGroupID;
    this.forumGroupName=this.$route.query.groupName;
    this.part=this.$route.query.part;
    this.getAllForumsList();
  },
  filters: {
    ellipsis(value) {
      if (!value) return;
      const date = new Date(value)
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return (
              year + '/' + month + '/' + day
      )
    }
  },
  methods: {

    /**
     * 设置帖子状态
     *
     * @param {object} row 所选对象信息
     * @param {number} type 所选状态类型
     */
    setForums(row, type) {
      const data = {
        forumId: row.forumId,
        categoryId:row.categoryId,
        customTitle:row.customTitle
      };
      if(type===0){
        data.isEssential=row.isEssential !== false
      }
      else if(type===1){
        data.isGroupTop=row.isGroupTop!== false
      }
      else if (type===2){
        data.isRecommended=row.isRecommended!== false
      }
      else if (type===3){
        data.isHideOnSquare=row.isHideOnSquare!==false
      }
      setForums(data).then(() => {
        this.$message({
          type: "success",
          message: "设置成功",
        });
        this.getAllForumsList();
      });
    },
    /**
     *
     */
    goBack() {
      this.$router.replace({
        name: "forum_page",
        params: {
          part: this.part,
          groupType:this.$route.query.groupType,
          userDataType:this.$route.query.userDataType,
          searchValue:this.$route.query.searchValue,
          currentPage:this.$route.query.currentPage
        }
      })
    },
    /**
     * 搜索
     */
    search() {
      this.currentPage = 1
      this.getAllForumsList()
    },
    /**
     * 重置
     */
    reset() {
      this.searchValue = ''
      this.getAllForumsList()
    },
    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage
      this.getAllForumsList()
    },
    /**
     *
     */
    getAllForumsList() {
      this.loading = true
      const params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyWord: this.searchValue,
      }
      let conditionsList = [{
        field: "forumGroupId",
        op: "equal",
        value: this.ForumGroupID,
      }];
      params.where=conditionsList

      setNavigationItemWithObj(this.navigationKey,{
        currentPage:this.currentPage,
        searchValue:this.searchValue,
        ForumGroupID:this.ForumGroupID
      })

      getAllForumsList(params).then(res => {
        this.allForumsList = res.data.rows
        this.totalCount = res.data.total
        this.utils.stopLoading(this)
      })
    },
    /**
     *
     */
    setPostTop(row) {
      const params = {
        ForumGroupID: this.ForumGroupID,
        ForumID: row.ForumID
      }
      setPostTop(params).then(() => {
        this.$message({
          type: 'success',
          message: '设置成功!'
        })
        this.getAllForumsList()
      })
    },
    /**
     * 删除/恢复帖子
     *
     * @param {object} row 所选对象信息
     */
    deleteOrBackForums(row) {
      // 判断操作类型
      let tips1, tips2
      if (row.isDeleted) {
        tips1 = '是否恢复该帖子'
        tips2 = '恢复成功!'
      } else {
        tips1 = '是否删除该帖子'
        tips2 = '删除成功'
      }

      const params = {
        forumId: row.forumId
      }
      this.$confirm(tips1, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          deleteOrBackForums(params).then(() => {
            this.$message({
              type: 'success',
              message: tips2
            })
            this.getAllForumsList();
          })
        })
        .catch(() => {
          this.$message('取消操作')
        })
    },
    /**
     * 跳转到帖子详情
     *
     * @param {object} row 所选对象信息
     */
    goToUltrasonicDetail(row) {
      go2UltrasonicDetail(this,row.forumId)
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
